import React from 'react';

export const EmrSubGroupMaster = () => {
  return <div>EmrSubGroupMaster</div>;
};
